import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '../translate/translate.service';

@Pipe({
    name: 'translate',
    pure: false // Mise à jour de la valeur lorsque nous changeons de langue
})

export class TranslatePipe implements PipeTransform {

	constructor(private _translate: TranslateService) { }

	transform(value: string, args: any[]): any {
		if (!value) return;
		
		return this._translate.instant(value);
	}
}
